import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  badge: 'New',
  title: 'Get real-time account notifications.',
  description:
    'Receive and configure real-time security alerts, account activity information, and the latest Zeller feature announcements, all in one convenient location.',
  point1: 'Receive Security alerts as events happen.',
  point2: 'Monitor user account permissions and activity.',
  point3: 'Get new Zeller feature announcements.',
  point4: 'Receive notifications via email and push to Zeller App.',
  primaryButtonLabel: 'View Notifications',
  secondaryButtonLabel: 'Close',
})
